import {
    COLOR,
} from '../../../business-const/Color/Color'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    formataPerc
} from '../../../business-components/Formata/Formata'

import {
    hipotesesRetornoRealProjetoVidaSonhoTracarMetaList,
    percHipotesesRetornoRealProjetoVidaSonhoTracarMetaList,
    coresHipotesesRetornoRealList,
    coresProjetoVidaSonhoTracarMetaList,
} from '../../../business-rules/List/hipotesesRetornoRealProjetoVidaSonhoTracarMetaList'

import {
    processaCalculoEstudo
} from '../estudo-form/EstudoServiceCalculo'

import {
    calculaTaxaJurosAnual
} from '../estudo-form/EstudoServiceMatematicaFinanceira'



export const incluiValorSimulacao = (graficoHipotesesRetornoReal,
    valorPresenteDeficitSimulacaoMensalValorDepositoViverRentabilidadeSaldoInicioAposentadoria, graficoProjetoVidaSonhoTracarMeta, 
        projetoVidaSonhoTracarMeta, percHipotesesRetornoRealProjetoVidaSonhoTracarMetaListAux, taxaRetornoAnualRealPonderada,
            diferenciarTaxasAposAposentadoria, taxaRetornoAnualRealAposAposentadoriaPonderada,
                coresHipotesesRetornoRealProjetoVidaSonhoTracarMetaListAux) => {

    graficoHipotesesRetornoReal.push(valorPresenteDeficitSimulacaoMensalValorDepositoViverRentabilidadeSaldoInicioAposentadoria)

    graficoProjetoVidaSonhoTracarMeta.push(
        projetoVidaSonhoTracarMeta
    )

    percHipotesesRetornoRealProjetoVidaSonhoTracarMetaListAux.push(
        formataPerc(taxaRetornoAnualRealPonderada) +
            (diferenciarTaxasAposAposentadoria ? ' / ' + formataPerc(taxaRetornoAnualRealAposAposentadoriaPonderada) : '')
    )

    coresHipotesesRetornoRealProjetoVidaSonhoTracarMetaListAux.push(
        COLOR().corChartHipotesesRetornoReal
    )
}

export const calcValorPresenteDeficitSimulacaoMensalValorAporteMensalPreservarReservaAposentadoria = (values) => {

    return (
        values.calcularHipotesesRetornoRealAposentadoriaViverRentabilidade
            ?
                values.valorAporteMensalPreservarReservaAposentadoria
            :
                values.valorPresenteDeficitSimulacaoMensal
    )
}

export const calculaGraficoHipotesesRetornoRealProjetoVidaSonhoTracarMeta = ( values, handleSubmitAutomatico,
    estudo, report, jsonConfiguracao, tipo ) => {

    let graficoHipotesesRetornoReal = []

    let graficoProjetoVidaSonhoTracarMeta = []

    let percHipotesesRetornoRealProjetoVidaSonhoTracarMetaListAux = []

    let coresHipotesesRetornoRealProjetoVidaSonhoTracarMetaListAux = []

    const valorPresenteDeficitSimulacaoMensalValorDepositoViverRentabilidadeSaldoInicioAposentadoria =
        calcValorPresenteDeficitSimulacaoMensalValorAporteMensalPreservarReservaAposentadoria(values)

    if (
            (
                valorPresenteDeficitSimulacaoMensalValorDepositoViverRentabilidadeSaldoInicioAposentadoria > 0 ||
                estudo.current.projetoVidaSonhoTracarMeta.length > 0
            ) &&
            (
                !values.naoExibirHipotesesRetornoRealAposentadoria ||
                values.exibirHipotesesRetornoRealProjetoVidaSonho
            )
    ) {

        const taxaCDIAnualAnt = values.taxaCDIAnual
        const retornoCDIAnt = values.retornoCDI
        const taxaJurosAnualAnt = values.taxaJurosAnual
        const tipoMomentoTributacaoIR = values.tipoMomentoTributacaoIR
        const percIR = values.percIR
        const tempoMinimoEntreAportesResgatesCalculoIRAnos = values.tempoMinimoEntreAportesResgatesCalculoIRAnos
        const utilizarPercRentabilidadeAnualRecursosFinanceiros = values.utilizarPercRentabilidadeAnualRecursosFinanceiros
        const diferenciarTaxasAposAposentadoria = values.diferenciarTaxasAposAposentadoria
        const taxaCDIAnualAposAposentadoria = values.taxaCDIAnualAposAposentadoria
        const retornoCDIAposAposentadoria = values.retornoCDIAposAposentadoria
        const taxaJurosAnualAposAposentadoria = values.taxaJurosAnualAposAposentadoria
        const taxaInflacaoAnualAposAposentadoria = values.taxaInflacaoAnualAposAposentadoria
        const taxaRetornoAnualRealAposAposentadoria = values.taxaRetornoAnualRealAposAposentadoria
        const taxaJurosAnualFgtsAposAposentadoria = values.taxaJurosAnualFgtsAposAposentadoria
        const taxaRetornoAnualFgtsRealAposAposentadoria = values.taxaRetornoAnualFgtsRealAposAposentadoria
        const taxaRetornoAnualRealPonderada = values.taxaRetornoAnualRealPonderada
        const taxaRetornoAnualRealAposAposentadoriaPonderada = values.taxaRetornoAnualRealAposAposentadoriaPonderada
        const projetoVidaSonhoTracarMeta = [...estudo.current.projetoVidaSonhoTracarMeta]
        
        let incluiValoresSimulacao = false

        values.taxaCDIAnual = 0
        values.retornoCDI = 0
        values.tipoMomentoTributacaoIR = ''
        values.percIR = ''
        values.tempoMinimoEntreAportesResgatesCalculoIRAnos = ''
        values.utilizarPercRentabilidadeAnualRecursosFinanceiros = false
        values.diferenciarTaxasAposAposentadoria = false

        hipotesesRetornoRealProjetoVidaSonhoTracarMetaList?.forEach(
            (linhaHipoteseRetornoRealProjetoVidaSonhoTracarMeta, index) => {

            values.taxaJurosAnual = calculaTaxaJurosAnual(linhaHipoteseRetornoRealProjetoVidaSonhoTracarMeta, values.taxaInflacaoAnual)

            processaCalculoEstudo(values, handleSubmitAutomatico, estudo, report, true,
                HARDCODE.origemCalculoEstudoEstudo, false, jsonConfiguracao, false)

            if (!incluiValoresSimulacao && taxaRetornoAnualRealPonderada < values.taxaRetornoAnualRealPonderada) {

                incluiValorSimulacao(graficoHipotesesRetornoReal,
                    valorPresenteDeficitSimulacaoMensalValorDepositoViverRentabilidadeSaldoInicioAposentadoria,
                        graficoProjetoVidaSonhoTracarMeta, projetoVidaSonhoTracarMeta,
                            percHipotesesRetornoRealProjetoVidaSonhoTracarMetaListAux, taxaRetornoAnualRealPonderada,
                                diferenciarTaxasAposAposentadoria, taxaRetornoAnualRealAposAposentadoriaPonderada,
                                    coresHipotesesRetornoRealProjetoVidaSonhoTracarMetaListAux)

                incluiValoresSimulacao = true
            }

            if (diferenciarTaxasAposAposentadoria || linhaHipoteseRetornoRealProjetoVidaSonhoTracarMeta !== taxaRetornoAnualRealPonderada) {
                
                graficoHipotesesRetornoReal.push(
                    calcValorPresenteDeficitSimulacaoMensalValorAporteMensalPreservarReservaAposentadoria(values)
                )

                graficoProjetoVidaSonhoTracarMeta.push(
                    [...estudo.current.projetoVidaSonhoTracarMeta]
                )

                percHipotesesRetornoRealProjetoVidaSonhoTracarMetaListAux.push(
                    percHipotesesRetornoRealProjetoVidaSonhoTracarMetaList[index]
                )

                coresHipotesesRetornoRealProjetoVidaSonhoTracarMetaListAux.push(
                    tipo === LABEL.aposentadoria ? coresHipotesesRetornoRealList[index] : coresProjetoVidaSonhoTracarMetaList[index]
                )
            }
        })

        if (!incluiValoresSimulacao) {

            incluiValorSimulacao(graficoHipotesesRetornoReal,
                valorPresenteDeficitSimulacaoMensalValorDepositoViverRentabilidadeSaldoInicioAposentadoria,
                    graficoProjetoVidaSonhoTracarMeta, projetoVidaSonhoTracarMeta,
                        percHipotesesRetornoRealProjetoVidaSonhoTracarMetaListAux, taxaRetornoAnualRealPonderada,
                            diferenciarTaxasAposAposentadoria, taxaRetornoAnualRealAposAposentadoriaPonderada,
                                coresHipotesesRetornoRealProjetoVidaSonhoTracarMetaListAux)
        }

        values.taxaCDIAnual = taxaCDIAnualAnt
        values.retornoCDI = retornoCDIAnt
        values.taxaJurosAnual = taxaJurosAnualAnt
        values.tipoMomentoTributacaoIR = tipoMomentoTributacaoIR
        values.percIR = percIR
        values.tempoMinimoEntreAportesResgatesCalculoIRAnos = tempoMinimoEntreAportesResgatesCalculoIRAnos
        values.utilizarPercRentabilidadeAnualRecursosFinanceiros = utilizarPercRentabilidadeAnualRecursosFinanceiros
        values.diferenciarTaxasAposAposentadoria = diferenciarTaxasAposAposentadoria
        values.taxaCDIAnualAposAposentadoria = taxaCDIAnualAposAposentadoria
        values.retornoCDIAposAposentadoria = retornoCDIAposAposentadoria
        values.taxaJurosAnualAposAposentadoria = taxaJurosAnualAposAposentadoria
        values.taxaInflacaoAnualAposAposentadoria = taxaInflacaoAnualAposAposentadoria
        values.taxaRetornoAnualRealAposAposentadoria = taxaRetornoAnualRealAposAposentadoria
        values.taxaJurosAnualFgtsAposAposentadoria = taxaJurosAnualFgtsAposAposentadoria
        values.taxaRetornoAnualFgtsRealAposAposentadoria = taxaRetornoAnualFgtsRealAposAposentadoria

        processaCalculoEstudo(values, handleSubmitAutomatico, estudo, report, true,
            report ? HARDCODE.origemCalculoEstudoEstudoReport : HARDCODE.origemCalculoEstudoEstudo,
                false, jsonConfiguracao, true)

        estudo.current.graficoHipotesesRetornoReal = graficoHipotesesRetornoReal

        estudo.current.graficoProjetoVidaSonhoTracarMeta = graficoProjetoVidaSonhoTracarMeta

        estudo.current.percHipotesesRetornoRealProjetoVidaSonhoTracarMetaList = percHipotesesRetornoRealProjetoVidaSonhoTracarMetaListAux

        estudo.current.coresHipotesesRetornoRealProjetoVidaSonhoTracarMetaList = coresHipotesesRetornoRealProjetoVidaSonhoTracarMetaListAux
    }
}

export const processaValoresDefaultIniciaisHipotesesRetornoRealProjetoVidaSonhoTracarMetaChart = ( values,
    handleSubmitAutomatico, estudo, report, jsonConfiguracao, tipo ) => {
    
    calculaGraficoHipotesesRetornoRealProjetoVidaSonhoTracarMeta(values, handleSubmitAutomatico, estudo, report,
        jsonConfiguracao, tipo)
}